<template>
  <section role="region" class="contact-form-section" id="contact-form">
    <div>
      <TheCard>
        <template #default style="position: relative;">
          <TheSecondHead
            chipText="Fale com o time"
            titleText="Não encontrou o que precisava?"
            subtitleText="Conte para a gente como podemos te ajudar"
          />
          <!-- :isDisabled="!captchaIsValid" -->
          <div class="maintenance-notice" role="status">
            <span class="maintenance-notice__icon" aria-hidden="true">
              <TheIcon icon="mdi-tools" :size="28" />
            </span>
            <h3>Formulário em manutenção</h3>
            <p>
              Estamos realizando melhorias neste canal de contato. Por favor,
              tente novamente mais tarde.
            </p>
          </div>
          <TheForm
            :formFields="formFields"
            :isLoading="isLoading"
            :is-disabled="true"
            @input-change="handleChange"
            @handle-submit="handleSubmit"
            ref="contactForm"
            style="opacity: 0.5 !important;"
          >
            <template #custom-fields>
              <label class="file-select" style="opacity: 0.5 !important;">
                <div class="select-button" style="opacity: 0.5 !important;">
                  <TheIcon icon="mdi-tray-arrow-down" :size="26" />
                  <span v-if="filesArray">{{ getFilesNames(filesArray) }}</span>
                  <span v-else class="label">Envie um arquivo</span>
                </div>
                <input
                  name="files"
                  type="file"
                  aria-label="Incluir arquivos"
                  @change="handleFileChange"
                  :disabled="true"
                  style="opacity: 0.5 !important;"
                />
              </label>
              <!-- <vue-recaptcha
                :modelValue="captchaValue"
                class="captcha-field"
                :sitekey="useCurrentEnvironment().site_key"
                size="normal"
                @verify="verifyMethod"
                @expired="expiredMethod"
              >
              </vue-recaptcha> -->
            </template>
          </TheForm>
        </template>
      </TheCard>
      <TheDialog
        :openDialog="openDialog"
        :dialogContent="dialogContent"
        @fechar-dialog="fecharDialog"
      ></TheDialog>
    </div>
  </section>
</template>

<script setup lang="ts">
import { VueRecaptcha } from "vue-recaptcha";

import { sendContactForm } from "~/composables/services/faq";

const formFields = ref<{ [key: string]: FormField }>({
  name: {
    name: "name",
    label: "Nome",
    type: "text",
    value: "",
    rules: [
      (value: string) => !!value || "Campo obrigatório.",
      (value: string) => (value && value.length >= 4) || "Mínimo 4 caracteres",
    ],
    appendInner: "mdi-account-outline",
    ariaLabel: "Campo para inclusão de nome",
  },
  email: {
    name: "email",
    label: "E-mail",
    type: "email",
    value: "",
    rules: [
      (value: string) => !!value || "Campo obrigatório.",
      (value: string) =>
        /.+@.+\..+/.test(value) || "O e-mail precisa ser válido",
    ],
    appendInner: "mdi-email-outline",
    ariaLabel: "Campo para inclusão de endereço eletrônico",
  },
  document: {
    name: "document",
    label: "CPF/CNPJ",
    type: "text",
    value: "",
    fieldMask: "cpf/cnpj",
    rules: [
      (value: string) => !!value || "Campo obrigatório.",
      (value: string) => {
        const raw = value?.replace(/[^a-zA-Z0-9]/g, "") || "";
        if (raw.length <= 11 && /[a-zA-Z]/.test(raw)) {
          return "CPF deve conter apenas números";
        }
        return true;
      },
      (value: string) =>
        (value && value.length >= 11) || "Mínimo 11 caracteres",
      (value: string) =>
        (value && value.length <= 18) || "Máximo 18 caracteres",
      (value) =>
        /([a-zA-Z0-9]{2}[\.]?[a-zA-Z0-9]{3}[\.]?[a-zA-Z0-9]{3}[\/]?[a-zA-Z0-9]{4}[-]?[0-9]{2})|([0-9]{3}[\.]?[0-9]{3}[\.]?[0-9]{3}[-]?[0-9]{2})/.test(
          value,
        ) || "O documento é invalido",
    ],
    appendInner: "mdi-account-box-outline",
    ariaLabel: "Campo para inclusão de documento",
  },
  subject: {
    name: "subject",
    label: "Mensagem",
    type: "textarea",
    value: "",
    rules: [
      (value: string) => !!value || "Campo obrigatório.",
      (value: string) => (value && value.length >= 3) || "Mínimo 3 caracteres",
    ],
    ariaLabel: "Campo para inclusão de mensagem",
  },
});
const filesArray = ref<FileList | null>(null);
const isLoading = ref<boolean>(false);
const captchaIsValid = ref<boolean>(false);
const captchaValue = ref<string | null>(null);
const openDialog = ref<boolean>(false);
const dialogContent = ref<DialogContent>({
  title: "",
  text: "",
  image: "",
});

const handleChange = (data: { name: string; value: string }) => {
  formFields.value[data.name].value = data.value;
};

const handleFileChange = (e: Event) => {
  const input = e.target as HTMLInputElement;
  filesArray.value = input.files;
};

const getFilesNames = (files: FileList | null) => {
  if (!files) return "";

  var filesName = [];

  for (var file in files) {
    if (files.hasOwnProperty(file)) {
      filesName.push((files as any)[file].name);
    }
  }

  return filesName.join(", ");
};

const abrirDialog = (type: string) => {
  openDialog.value = true;
  if (type == "success") {
    dialogContent.value = {
      title: "Mensagem enviada!",
      text: "Logo retornaremos o contato",
      image: "/icons/success-modal.svg",
    };
    return;
  }

  dialogContent.value = {
    title: "Mensagem não enviada!",
    text: "Tente novamente em alguns segundos",
    image: "/icons/error-modal.svg",
  };
};

const fecharDialog = () => {
  openDialog.value = false;
};

const resetForm = () => {
  captchaValue.value = null;
  filesArray.value = null;
  isLoading.value = false;
};

const buildFormData = () => {
  const formData = new FormData();

  for (const [key, input] of Object.entries(formFields.value)) {
    formData.append(key, String((input.value ?? "").trim()));
  }

  if (captchaValue.value) {
    formData.append("captcha", captchaValue.value);
  }

  if (filesArray.value) {
    for (const file of Array.from(filesArray.value)) {
      formData.append("uploaded_data", file, file.name);
    }
  }

  return formData;
};

const handleSubmit = async () => {
  if (isLoading.value || !captchaIsValid.value || !captchaValue.value) return;

  isLoading.value = true;
  const formData = buildFormData();
  sendContactForm(formData)
    .then((response: any) => {
      abrirDialog("success");
      resetForm();
    })
    .catch((e: any) => {
      console.error("Erro ao enviar contato:", e);
      abrirDialog("error");
      return;
    })
    .finally(() => {
      isLoading.value = false;
    });
};

const verifyMethod = (token: any) => {
  if (token) {
    captchaValue.value = token;
    captchaIsValid.value = true;
  }
};

const expiredMethod = (token: any) => {
  if (!token) {
    captchaValue.value = null;
    captchaIsValid.value = false;
  }
};
</script>

<style lang="scss">
@use "@/styles/variables" as *;

.contact-form-section {
  background-image: url(@/assets/images/contact/bg-mobile.webp);
  background-color: $greyLight;
  background-repeat: no-repeat;
  background-position: center 100%;
  margin: 0px -20px;
  padding: 1px 20px;
  max-width: none;
  background-size: 360px 1380px;

  // card temporario:
  .default-card {
    position: relative;

    .maintenance-notice {
      position: absolute;
      top: 50%;
      left: 50%;
      z-index: 1;
      width: min(330px, calc(100% - 40px));
      padding: 28px 24px;
      color: $greyDark;
      background: $white;
      border: 2px solid #3303ff;
      border-radius: 16px;
      box-shadow: 0 12px 30px $shadowColor;
      text-align: center;
      transform: translate(-50%, -50%);

      &__icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 56px;
        height: 56px;
        margin-bottom: 16px;
        color: $blue;
        background-color: $blueLight;
        border-radius: 50%;
      }

      h3 {
        margin: 0 0 12px;
        color: $blueGrey;
        font-size: 20px;
        line-height: 1.25;
      }

      p {
        margin: 0;
        font-size: 14px;
        line-height: 1.55;
      }
    }
    // fim card temporario

    padding: 48px 20px;
    max-width: 480px;
    margin: 175px auto 266px;
    border: 2px solid #3303ff;
    min-height: 939px;

    .title {
      margin: 16px auto;
    }

    .subtitle {
      width: 280px;
      margin-bottom: 28px;
    }

    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active {
      -webkit-transition: background-color 9999s ease-in-out 0s;
      -moz-transition: background-color 9999s ease-in-out 0s;
      -o-transition: background-color 9999s ease-in-out 0s;
      transition: background-color 9999s ease-in-out 0s;
    }

    .v-field,
    .mdi {
      --v-medium-emphasis-opacity: 1 !important;
      color: $greyDark;
    }

    .form-field .v-text-field,
    .file-select > .select-button {
      width: 280px;
      margin: 0 auto;
    }

    .form-field .v-input__details {
      height: 24px;
    }

    .form-field:nth-child(4) .v-input__details {
      height: 16px;
    }

    .file-select {
      width: 100%;

      .default-icon {
        -webkit-transform: rotate(180deg);
        transform: rotate(180deg);
        margin-bottom: 9px;
      }
    }

    .file-select > .select-button {
      color: $greyDark;
      font-size: 14px;
      line-height: normal;
      border: 1px dashed $greyDark;
      border-radius: 9px;
      padding: 24px 00px 21px;
      font-weight: 600 !important;
    }

    .file-select > input[type="file"] {
      display: none;
    }

    .v-field__outline {
      --v-field-border-opacity: 1;
    }

    .captcha-field {
      margin-top: 16px;
      -webkit-transform: scale(0.92);
      transform: scale(0.92);
      display: flex;
      justify-content: center;
    }

    .default-button {
      margin-top: 34px;
    }
  }

  @media screen and (min-width: 834px) and (max-width: 1199px) {
    background-image: url(@/assets/images/contact/bg-tablet.webp);
    background-size: 802px 525px;

    .default-card {
      width: 480px;
      height: 1020px;
      margin: 68px auto;
      text-align: center;

      .captcha-field {
        display: flex;
        justify-content: center;
      }
    }
  }

  @media screen and (min-width: 834px) {
    margin: 0px;

    .default-card {
      margin: 68px auto;

      .title {
        width: 70%;
      }

      .subtitle {
        width: 357px;
        margin: 0px 4em 28px;
      }

      .form-field .v-text-field,
      .file-select > .select-button {
        width: 357px;
      }

      .captcha-field {
        -webkit-transform: unset;
        transform: unset;
      }
    }
  }

  @media screen and (min-width: 1200px) {
    background-image: url(@/assets/images/contact/bg-desk.webp);
    background-size: 1122.94px 733px;

    .default-card {
      .title {
        margin-bottom: 24px;
      }

      .subtitle {
        margin: 0px 4em 34px;
      }
    }
  }
}
</style>
